import Tooltip from "./Tooltip";

const LargeTextTableCell = ({
  $compressedUI,
  value,
  maxHeight = "85px",
}: {
  $compressedUI: boolean;
  value: string;
  maxHeight?: string;
}): React.JSX.Element => {
  return (
    <p
      style={{
        transition: "all 0.3s ease",
        margin: 0,
        maxHeight: maxHeight || "160px",
        height: $compressedUI ? "auto" : "65px",
        textOverflow: typeof value === "string" ? "ellipsis" : "unset",
        whiteSpace: $compressedUI ? "nowrap" : "normal",
        overflow: $compressedUI ? "hidden" : "auto",
        alignContent: "center",
      }}
    >
      {$compressedUI ? <Tooltip content={value}>{value}</Tooltip> : value}
    </p>
  );
};
export default LargeTextTableCell;
